export const userManagementPagingSelector = state => state.list.userManagementPaging;
export const userManagementRowsPerPageSelector = state => state.list.userManagementRowsPerPage;
export const userManagementSearchValueSelector = state => state.list.userManagementSearchValue;
